import * as React from "react"
import { ChevronLeft, ChevronRight } from "lucide-react"
import { DayPicker } from "react-day-picker"

import { cn } from "@/lib/utils"

function Calendar({
  className,
  classNames,
  showOutsideDays = true,
  ...props
}) {
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      weekStartsOn={0}
      className={cn("rounded-[10px] bg-white p-5 text-[#111827]", className)}
      classNames={{
        root: "w-[302px] max-w-[calc(100vw-3rem)]",
        months: "relative flex flex-col",
        month: "w-full",
        month_caption: "pointer-events-none relative mb-5 flex h-8 items-center justify-center",
        caption_label: "pointer-events-none text-[22px] font-bold leading-none text-black",
        nav: "absolute inset-x-0 top-0 z-20 flex h-8 items-center justify-between",
        button_previous:
          "relative z-30 grid h-8 w-8 place-items-center rounded-full text-black transition hover:bg-[#f2f5fa] focus:outline-none focus:ring-2 focus:ring-[#06386f]/25 disabled:cursor-not-allowed disabled:opacity-35",
        button_next:
          "relative z-30 grid h-8 w-8 place-items-center rounded-full text-black transition hover:bg-[#f2f5fa] focus:outline-none focus:ring-2 focus:ring-[#06386f]/25 disabled:cursor-not-allowed disabled:opacity-35",
        month_grid: "w-full border-collapse",
        weekdays: "grid grid-cols-7",
        weekday: "h-8 text-center text-[12px] font-normal leading-8 text-[#7c8290]",
        week: "mt-1 grid grid-cols-7",
        day: "grid h-10 place-items-center p-0 text-center",
        day_button:
          "grid h-9 w-9 place-items-center rounded-[8px] text-[16px] font-normal text-[#202124] transition hover:bg-[#edf4ff] focus:outline-none focus:ring-2 focus:ring-[#06386f]/25 aria-selected:bg-[#06386f] aria-selected:text-white aria-selected:hover:bg-[#06386f]",
        selected: "[&>button]:bg-[#06386f] [&>button]:text-white [&>button]:hover:bg-[#06386f]",
        today: "[&>button]:font-semibold",
        outside: "[&>button]:pointer-events-none [&>button]:text-[#b8bdc7]",
        disabled: "[&>button]:cursor-not-allowed [&>button]:text-[#c4c8d0] [&>button]:opacity-60",
        hidden: "invisible",
        ...classNames,
      }}
      components={{
        Chevron: ({ className, orientation, ...props }) =>
          orientation === "left" ? (
            <ChevronLeft className={cn("h-5 w-5", className)} {...props} />
          ) : (
            <ChevronRight className={cn("h-5 w-5", className)} {...props} />
          ),
      }}
      {...props} />
  );
}
Calendar.displayName = "Calendar"

export { Calendar }
